<template>
  <form @submit.prevent="handleSubmit" class="side-wrapper side-wrapper-flex">
    <!-- Header -->
    <div class="side-header">
      <div class="side-wrapper-subtitle">{{ generalStore.viewHeader }}</div>
      <h1>{{ $gettext("Checkin log") }}</h1>
    </div>

    <!-- Body -->
    <div class="side-body">
      <pre>{{ form }}</pre>
    </div>

    <!-- Footer -->
    <div class="side-footer">
      <NiceActions @cancel="cancel" :loading="loading" />
    </div>
  </form>
</template>

<script setup>
import { defineProps, onMounted, defineEmits, ref } from "vue";

import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();

import { useRouter } from "vue-router";
const router = useRouter();

import { useGeneralStore } from "@/store/general.store";
const generalStore = useGeneralStore();

import ApiService from "@/services/api/api.service";
import { clone } from "@/plugins/query";

const organizationId = router.currentRoute.value.params.organizationId;
const eventId = router.currentRoute.value.params.eventId;

const emit = defineEmits(["cancel", "success"]);
const props = defineProps({
  data: {
    type: Object,
    required: false,
  },
});
const form = ref({});
const loading = ref(false);

function cancel() {
  emit("cancel");
}

onMounted(async () => {
  const checkinLogId = router.currentRoute.value.query.id;
  if (checkinLogId == "new") return;
  if (props.data) return (form.value = clone(props.data));

  try {
    form.value = await ApiService.checkinLogs.get(organizationId, eventId, checkinLogId);
  } catch (e) {
    emit("cancel");
  }
});
</script>
